import { render, staticRenderFns } from "./CreateNoteButton.vue?vue&type=template&id=aaabdfd0&"
import script from "./CreateNoteButton.vue?vue&type=script&lang=js&"
export * from "./CreateNoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports